// extracted by mini-css-extract-plugin
export default {"global-layout":"Settings_global-layout__7tbMn","global-layout__body":"Settings_global-layout__body__HQ6Dx","global-layout__body--body":"Settings_global-layout__body--body__nTP+i"};